import { render, staticRenderFns } from "./EmployeeViewInfo.vue?vue&type=template&id=6cf4b8a7&"
import script from "./EmployeeViewInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports